import { useEffect, useContext } from 'react';
import { useLocation } from 'react-router';
import { useSelector } from 'react-redux';

import { FeedbackUIContext } from '#context/feedback-ui-context';
import { useGetVendorMutation } from '#services/vendor';

export interface VendorFormState {
  id: number | null;
  name: string;
  description: string;
  notes: string;
  relatedProducts: unknown[];
  [key: string]: unknown;
}

export const getInitialState = (plainData?: unknown): VendorFormState => {
  const initialState: VendorFormState = {
    id: null,
    name: '',
    description: '',
    notes: '',
    relatedProducts: [],
  };

  let state = plainData
    ? JSON.parse(JSON.stringify(plainData))
    : initialState;
  state = Object.assign({}, initialState, state);

  return state;
};

export function useData({
  resetForm,
}: {
  resetForm: (state: VendorFormState) => void;
}) {
  const location = useLocation();
  const filter = useSelector((state: { vendorList: { filter: string } }) => state.vendorList.filter);
  const order = useSelector((state: { vendorList: { order: string } }) => state.vendorList.order);
  const orderBy = useSelector((state: { vendorList: { orderBy: string } }) => state.vendorList.orderBy);

  const {
    showBackdrop,
    hideBackdrop,
    simpleSnackbar,
  } = useContext(FeedbackUIContext)!;

  const [getVendor] = useGetVendorMutation();

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const vendorId = Number(urlParams.get('vendorId')) || undefined;
    const vendorIndex = Number(urlParams.get('vendorIndex')) || undefined;

    if (!vendorId && !vendorIndex) {
      resetForm(getInitialState());
      return;
    }

    showBackdrop();
    void getVendor({
      filter,
      order,
      orderBy,
      vendorId,
      vendorIndex,
    })
      .then((res) => {
        const hasError = simpleSnackbar(res as unknown as Parameters<typeof simpleSnackbar>[0]);
        if (hasError) {
          return;
        }

        resetForm(getInitialState(res.data));
      })
      .finally(() => {
        hideBackdrop();
      });
  }, [location.key]);
}
